import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';


const TooltipTable = styled.table`
  white-space: nowrap;
`;

const NavToolTip = ({
  toolTipData = [],
}) =>
  <TooltipTable>
    <tbody>
      {toolTipData
        ?.filter(t => t.value)
        ?.map((toopTip, key) => <tr key={key}>
          <td data-test-id='menu-tooltip.lable'>
            {toopTip.label}:
          </td>
          <td data-test-id='menu-tooltip.value'>
            {toopTip.value}
          </td>
        </tr>,
        )}
    </tbody>
  </TooltipTable>;

NavToolTip.propTypes = {
  toolTipData: PropTypes.object,
};

export default NavToolTip;
